export const faqData = {
  FAQ: [
    {
      id: 1,
      question: "What is Meducate AI?",
      answer:
        "Meducate AI is an educational platform that empowers doctors with custom, AI-generated patient education videos. These videos are designed to save time, improve communication, and enhance patient understanding—leading to better outcomes.",
    },
    {
      id: 2,
      question: "Who creates the videos?",
      answer:
        "Each video is generated using advanced AI tools and guided by real medical professionals. Doctors on our advisory board review and approve scripts, ensuring accuracy, clarity, and clinical relevance.",
    },
    {
      id: 3,
      question: "What types of topics are covered?",
      answer:
        "We cover a wide range of medical topics—from common procedures and chronic condition management to mental health, preventative care, and pediatric education. We’re always adding to the library based on physician feedback and patient demand",
    },
    {
      id: 4,
      question: "How can these videos help my practice?",
      answer:
        "Meducate videos reduce repetitive explanations, increase patient comprehension, improve appointment efficiency, reduce cancellations, and lower callback rates. They also help patients feel more confident and informed, boosting satisfaction scores.",
    },
    {
      id: 5,
      question: "Are the videos customizable for my practice?",
      answer:
        "Yes. Each video is designed to reflect your voice and tone, and we offer customization options for practice-specific instructions, branding, or treatment protocols.",
    },
    {
      id: 6,
      question: "How do patients access the videos?",
      answer:
        "You can share Meducate videos through a secure link via text and email, or display them in-office using tablets or screens. Patients can access them before or after appointments, on their own time.",
    },
    {
      id: 7,
      question: "Does Meducate AI follow HIPAA-compliance?",
      answer:
        "We take data privacy and security seriously. While our videos do not contain personal health information (PHI), our app is designed to support HIPAA-compliant use. All user interactions and communications are handled through secure, HIPAA-aligned systems and practices.",
    },
    {
      id: 8,
      question: "What does it cost?",
      answer:
        "Meducate AI is available through a subscription model. Individual physicians pay a flat monthly rate based on specialty. Group discounts are available based on the number of providers. Contact us for a custom quote.",
    },
    {
      id: 9,
      question: "How long does it take to get started?",
      answer:
        "Most practices can begin using Meducate within 24–48 hours. Once your profile is set up, you’ll have access to our full video library and onboarding tools.",
    },
    {
      id: 10,
      question: "Can I request a new video topic?",
      answer:
        "Absolutely. We welcome physician input and prioritize new video production based on relevance and demand. If there’s something your patients frequently ask about, we’ll help you answer it—clearly and efficiently.",
    },
  ],
};
